import {isNullOrUndefined} from "../../../services/Validator";

function ThemesLayout({children}) {
    // Used in ThemesContent to frame Themes
    // content made of intro text and Themes list

    // BUILD
    if (isNullOrUndefined(children))
        return null
    return (
        <div className={"overflow-auto bg-backgroundLight3 w-full grow flex flex-col justify-start items-center"}>
            {children}
        </div>
    );
}

// EXPORT
export default ThemesLayout